module.exports = __webpack_public_path__ + "media/images/icon-experience-strategy-0a8ba15065251e319a3ad6ae6d95e702.svg";